import { defineMessages } from 'react-intl';

export default defineMessages({
  instructions: {
    id: 'sentinel.components.amountAvailablePanel.instructions',
    defaultMessage: 'Instructions',
  },
});



// WEBPACK FOOTER //
// ./src/components/WireInstructionsPanel/messages.js